// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  version: "0.0.1",
  firebaseConfig: {
    apiKey: "AIzaSyDVxoc17mEi0wAKRQH0Im7vXNI-nEMqrz8",
    authDomain: "rengo-urbano-oriente.firebaseapp.com",
    databaseURL: "https://rengo-urbano-oriente.firebaseio.com",
    projectId: "rengo-urbano-oriente",
    storageBucket: "rengo-urbano-oriente.appspot.com",
    messagingSenderId: "786742675413",
    appId: "1:786742675413:web:4b640e93cb3aece0459f5c",
    measurementId: "G-LTSYD9SXKE"
  }
};
